import { ReactElement } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';

/**
 * Flex-box enabled row container to fill entire width with child elements
 * @param {Object} props
 * @param {ReactElement} props.children child components to display
 * @returns {ReactElement} stylized component to display `NavCard` components in a row
 */
const NavRow = ({ children }) => {
	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'row',
				flexWrap: 'wrap',
				justifyContent: 'space-evenly',
				alignItems: 'stretch',
			}}
		>
			{children}
		</Box>
	);
};

NavRow.propTypes = {
	children: PropTypes.node,
};
export default NavRow;
//TODO - relocate this and `NavCard` to more global location
